<my-app-sidenav></my-app-sidenav>
<section id="page-container" class="app-page-container container-fluid">
  <my-app-header></my-app-header>

  <div class="app-content-wrapper">
    <div class="app-content">
      <div class="full-height">
        <router-outlet></router-outlet>
      </div>
    </div>
    <fab-menu [itens]="fabMenuLista"></fab-menu>
    <my-app-footer></my-app-footer>
  </div>
</section>
<right-panel></right-panel>
<simple-notifications></simple-notifications>
<!-- <my-app-customizer></my-app-customizer> -->

<!-- <my-app-search-overlay></my-app-search-overlay> -->